import React from 'react';
import { Link } from 'react-router-dom';
import './CSS/PoliticaCookies.css';

const PoliticaCookies = () => {
  return (
    <div className="legal-page-container">
      <div className="legal-page-content">
        <h1>Política de Cookies</h1>

        <section className="legal-section">
          <p>
            El sitio web intoreality.tv utiliza una tecnología llamada 'cookie', con el fin de poder obtener información sobre el uso del sitio web, mejorar la experiencia del usuario y garantizar su correcto funcionamiento.
          </p>
        </section>

        <section className="legal-section">
          <h2>Definición de Cookie</h2>
          <p>
            Una 'cookie' es un pequeño fragmento de texto que los sitios web envían al navegador y que se almacena en el terminal del usuario (ordenador o dispositivo móvil). Estos archivos tienen la finalidad de almacenar datos que podrán ser actualizados y recuperadas por la entidad responsable de su instalación. Así, cada vez que el usuario vuelve a visitar el mismo sitio web, el explorador recupera el archivo y lo envía al servidor del sitio web.
          </p>
          <p>
            Las cookies tienen varias funciones entre las que se incluyen, la de recoger información sobre las preferencias del usuario y recordarla, y en general, facilitar el uso del sitio web al usuario haciendo que el sitio sea más útil al personalizar su contenido.
          </p>
        </section>

        <section className="legal-section">
          <h2>Tipos de Cookies</h2>
          <p>Las cookies se pueden clasificar en base a diferentes parámetros:</p>

          <div className="cookie-type">
            <h3>Según la titularidad</h3>
            <p><strong>Cookies propias y cookies de terceros:</strong> dependiendo de cuál sea la entidad que gestione el dominio desde donde se envían las cookies y se traten los datos que se obtengan.</p>
          </div>

          <div className="cookie-type">
            <h3>Según la duración</h3>
            <p><strong>Cookies de sesión y cookies persistentes:</strong> de acuerdo con el plazo de tiempo que permanecen almacenadas en el terminal del usuario.</p>
          </div>

          <div className="cookie-type">
            <h3>Según la finalidad</h3>

            <div className="cookie-category">
              <h4>Cookies técnicas</h4>
              <p>Son aquellas que permiten al usuario la navegación a través de la página web o aplicación y la utilización de las diferentes opciones o servicios que en ella existen. Por ejemplo, controlar el tráfico y la comunicación de datos, identificar la sesión o acceder a las partes web de acceso restringido.</p>
            </div>

            <div className="cookie-category">
              <h4>Cookies de preferencias o personalización</h4>
              <p>Son aquellas que permiten recordar información para que el usuario acceda al servicio con determinadas características que pueden diferenciar su experiencia de la de otros usuarios, como, por ejemplo, el idioma, el número de resultados a mostrar cuando el usuario realiza una búsqueda, el aspecto o contenido del servicio en función del tipo de navegador a través del cual el usuario accede al servicio o de la región desde la que accede al servicio, etc.</p>
            </div>

            <div className="cookie-category">
              <h4>Cookies de análisis o medición</h4>
              <p>Son aquellas que permiten a su responsable el seguimiento y el análisis del comportamiento de los usuarios de los sitios web a los que están vinculadas, incluida la cuantificación de los impactos de los anuncios. La información recogida mediante este tipo de cookies se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma, con el fin de introducir mejoras en función del análisis de los datos de uso que hacen los usuarios del servicio.</p>
            </div>

            <div className="cookie-category">
              <h4>Cookies de publicidad comportamental</h4>
              <p>Son aquellas que almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función de este perfil.</p>
            </div>
          </div>
        </section>

        <section className="legal-section">
          <h2>Cookies utilizadas en nuestro sitio web</h2>
          <p>
            Nuestro sitio web utiliza tanto cookies propias, que son las enviadas a su dispositivo y gestionadas exclusivamente por nosotros para el mejor funcionamiento del sitio web, como cookies de terceros, con la función de servirnos como herramienta de análisis de la interacción los usuarios con nuestra web, gracias a ellas obtenemos una información que puede ayudar a mejorar la navegación y dar un mejor servicio a los usuarios.
          </p>
          <p>
            Utilizamos tanto cookies temporales de sesión como cookies persistentes. Las cookies de sesión almacenan datos únicamente mientras el usuario accede a la web y las cookies persistentes almacenan los datos en el terminal para que sean accedidas y utilizadas en más de una sesión.
          </p>

          <div className="cookie-info-box">
            <h3>Cookies propias</h3>
            <p>Las cookies propias que utilizamos en nuestro sitio web son de carácter técnico, fundamentales para el funcionamiento de la web.</p>
          </div>

          <p>Para obtener más información sobre las cookies y/o para su desactivación puede clicar sobre los enlaces que hay en el nombre de los diferentes titulares.</p>
          <p>Finalmente, también se utilizan cookies de complemento (plug-in) para intercambiar contenidos sociales.</p>
        </section>

        <section className="legal-section">
          <h2>Consentimiento</h2>
          <p>
            El consentimiento para el uso de las cookies antes enunciadas, por los plazos señalados y en las condiciones contenidas en la presente Política de Cookies, se obtendrá con la aceptación del aviso inicial de información sobre las cookies que se visualiza en el momento en que carga nuestra web.
          </p>
          <p>
            Asimismo, le informamos de que si usted consulta contenidos en nuestra web alojados en webs de terceros, estos tienen su propia política de cookies.
          </p>
        </section>

        <section className="legal-section">
          <h2>Retirada del consentimiento</h2>
          <p>
            El usuario puede retirar su consentimiento para el uso de cookies en cualquier momento. Para ello, puede usar el botón de <Link to="/configuracion-cookies" className="legal-inline-link">Configuración de Cookies</Link> o eliminar las cookies de su navegador.
          </p>
        </section>

        <section className="legal-section">
          <h2>Modificación de la configuración de las cookies</h2>
          <p>
            El usuario puede restringir, bloquear o borrar las cookies de cualquier sitio web, utilizando su navegador. En cada navegador la operativa es diferente, por lo que puede consultar los siguientes enlaces la forma de hacerlo:
          </p>

          <ul className="browser-links-list">
            <li>
              <strong>Internet Explorer:</strong> <a href="https://support.microsoft.com/es-es/help/17442/windows-internet-explorer-delete-manage-cookies#ie=ie-11" target="_blank" rel="noopener noreferrer">Gestionar cookies en IE</a>
            </li>
            <li>
              <strong>Edge:</strong> <a href="https://support.microsoft.com/es-es/help/4468242/microsoft-edge-browsing-data-and-privacy-microsoft-privacy" target="_blank" rel="noopener noreferrer">Gestionar cookies en Edge</a>
            </li>
            <li>
              <strong>Firefox:</strong> <a href="https://support.mozilla.org/es/kb/clear-cookies-and-site-data-firefox" target="_blank" rel="noopener noreferrer">Gestionar cookies en Firefox</a>
            </li>
            <li>
              <strong>Chrome:</strong> <a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer">Gestionar cookies en Chrome</a>
            </li>
            <li>
              <strong>Safari (Mac):</strong> <a href="https://support.apple.com/es-es/guide/safari/manage-cookies-and-website-data-sfri11471/mac" target="_blank" rel="noopener noreferrer">Gestionar cookies en Safari Mac</a>
            </li>
            <li>
              <strong>Safari (iPhone/iPad):</strong> <a href="https://support.apple.com/es-es/HT201265" target="_blank" rel="noopener noreferrer">Gestionar cookies en Safari iOS</a>
            </li>
            <li>
              <strong>Opera:</strong> <a href="https://help.opera.com/en/latest/web-preferences/#cookies" target="_blank" rel="noopener noreferrer">Gestionar cookies en Opera</a>
            </li>
          </ul>

          <p>
            Para obtener más información sobre la eliminación, deshabilitación o bloqueo de las cookies también puede visitar: <a href="https://www.aboutcookies.org/how-to-manage-and-delete-cookies" target="_blank" rel="noopener noreferrer" className="legal-inline-link">aboutcookies.org</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>Actualización de la política de cookies</h2>
          <p>
            Este sitio web puede modificar esta Política sobre Cookies, por ello le recomendamos revisar esta política cada vez que acceda a nuestro sitio web para estar adecuadamente informado sobre el uso que hacemos de las cookies.
          </p>
        </section>

        <div className="legal-back-link">
          <Link to="/">Volver al Inicio</Link>
        </div>
      </div>
    </div>
  );
};

export default PoliticaCookies;
